import { Controller } from 'stimulus';

export default class extends Controller {
  static values = { collectorManagersUrl: String };
  static targets = ['collectorSegmentedLists', 'collectorManagers'];

  connect() {
    const self = this;

    this.currentSegmentedList = this.collectorSegmentedListsTarget.value;
    this.$select = $(this.collectorManagersTarget).select2({
      width: '100%',
      closeOnSelect: false,
      ajax: {
        dataType: 'json',
        delay: 400,
        data: (params) => {
          var query = {
            search: params.term,
            page: params.page || 1
          }

          // Query parameters will be ?search=[term]&page=[page]
          return query;
        },
        url: (params) => {
          if (self.currentSegmentedList) {
            return self.currentManagersUrl;
          }
          return false;
        }
      }
    });
  }

  updateCollectorManagers() {
    this.currentSegmentedList = this.collectorSegmentedListsTarget.value;
    this.$select.val(null).trigger('change');
  }

  get currentSegmentedList() {
    return this._currentSegmentedList;
  }

  set currentSegmentedList(value) {
    this._currentSegmentedList = value;
    if (this._currentSegmentedList) {
      this.currentManagersUrl = this.collectorManagersUrlValue.replace('SEGMENTED_LIST_ID', this._currentSegmentedList);
    } else {
      this.currentManagersUrl = null;
    }
  }
}
